module.exports = __webpack_public_path__ + "img/Helmond-Sport.2335f0af.png";